import React from 'react';
import { TripHistories } from '@marageti/z4-sdk/lib/travel';
import { useApiClient, useFetch } from '@marageti/z4-lib';
import { useAuthStore } from '../../store';
import HomeView from './home-view';

const HomeContainer = () => {
  const { loggedInTraveler } = useAuthStore();
  const apiClient = useApiClient();
  const travelerId = loggedInTraveler?.id;

  const { data: tripsData, isLoading, error } = useFetch<TripHistories>(
    apiClient.peopleClient.getTravelerTripHistories,
    [travelerId],
    !!travelerId,
  );

  return (
    <HomeView
      travelerId={travelerId || ''}
      activeTrips={tripsData?.activeTrips || []}
      pastTrips={tripsData?.pastTrips || []}
      archivedTrips={tripsData?.archivedTrips || []}
      reviewPromptTrips={tripsData?.reviewPromptTrips || []}
      loading={isLoading}
      error={error}
      showAnnouncementBanner
    />
  );
};

export default HomeContainer;
